var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "customDetailComponents" }, [
    _c("div", { staticClass: "toConfigure" }, [
      _vm.fromArray.length !== 0
        ? _c(
            "div",
            { staticClass: "customDetailFrom" },
            [
              _c("FormLayout", {
                ref: "FormLayout",
                attrs: {
                  defaultColumn: _vm.defaultColumn,
                  defaultconfig: _vm.fromConfig,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "customDetailTable" },
        [
          _c("div", { staticClass: "page_content" }, [
            _c(
              "div",
              { staticClass: "page_box" },
              [
                _c("Page", {
                  attrs: {
                    size: "small",
                    "page-size-opts": _vm.pageSizeOpts,
                    total: _vm.totalRowCount,
                    "show-elevator": "",
                    "show-sizer": "",
                    "show-total": "",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "page_btn" }, [
                  _vm._v("【删除明细】"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "page_btn" }, [_vm._v("【导入】")]),
                _vm._v(" "),
                _c("span", { staticClass: "page_btn" }, [_vm._v("【导出】")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "search_box" },
              [
                _c(
                  "Select",
                  {
                    staticStyle: { width: "120px", "margin-right": "8px" },
                    attrs: { placeholder: "查询条件" },
                    model: {
                      value: _vm.model1,
                      callback: function ($$v) {
                        _vm.model1 = $$v
                      },
                      expression: "model1",
                    },
                  },
                  _vm._l(_vm.cityList, function (item) {
                    return _c(
                      "Option",
                      { key: item.value, attrs: { value: item.value } },
                      [_vm._v(_vm._s(item.label))]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "Input",
                  {
                    staticStyle: { width: "160px" },
                    attrs: { search: "" },
                    model: {
                      value: _vm.searchValue,
                      callback: function ($$v) {
                        _vm.searchValue = $$v
                      },
                      expression: "searchValue",
                    },
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "prepend" }, slot: "prepend" },
                      [_vm._v("搜索")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("Table", {
            staticStyle: { "margin-top": "8px" },
            attrs: { height: "200", columns: _vm.columns, data: _vm.data },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "customizedPage" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }